








































































































































import Vue from "vue";
import SuperPayPayment from "@/components/PaymentMethods/SuperPayPayment.vue";
import CustomPayment from "@/components/PaymentMethods/CustomPayment.vue";
import LivenPayment from "@/components/PaymentMethods/LivenPayment.vue";
import CashMachine from "@/components/PaymentMethods/CashMachine.vue";
import { PaymentMethodsService } from "@/services/paymentMethodsService";
import { Info } from "@/models/Info";

export default Vue.extend({
  name: "PaymentMethods",
  components: {
    SuperPayPayment,
    CustomPayment,
    LivenPayment,
    CashMachine
  },
  props: {
    info: {
      type: Object as () => Info,
      default: null
    }
  },
  data() {
    return {
      saving: false,
      editValue: null as any,
      editModalVisible: false,
      disableCashPayment: false,
      paymentMethods: {} as any,
      selectedPaymentType: "",
      CustomPaymentProviderMode: false,
      showCustomPayment: false,
      isSettingChanged: false
    };
  },
  created() {
    this.paymentMethods = this.selectedDevicePaymentMethods;
  },
  watch: {
    "info.selectedDevice"(newValue) {
      this.paymentMethods = this.selectedDevicePaymentMethods;
      this.CustomPaymentProviderMode = this.paymentMethods.CustomPaymentProvider;
    },
    CustomPaymentProviderMode(newValue) {
      if (newValue) {
        this.paymentMethods.CustomPaymentProvider = newValue;
      } else {
        this.paymentMethods.CustomPaymentProvider = 0;
      }
    }
  },
  computed: {
    selectedDevicePaymentMethods(): any {
      return this.info.cloudSettings.find(p => p.deviceUDID == this.info.selectedDevice.deviceUDID)!.userDefaultsObject;
    }
  },
  methods: {
    editOtherPayment(paymentType) {
      this.selectedPaymentType = paymentType;
      this.showCustomPayment = false;
    },
    editCustomPayment() {
      this.showCustomPayment = true;
    },
    settingChanged() {
      this.isSettingChanged = true;
    },
    async Save() {
      try {
        this.saving = true;
        let data = {};
        const customRef = this.$refs.CustomPaymentRef as any;
        const SuperPayPaymentRef = this.$refs.SuperPayPaymentRef as any;
        const LivenPaymentRef = this.$refs.LivenPaymentRef as any;
        const CashMachineRef = this.$refs.CashMachineRef as any;
        if (customRef) {
          data = Object.assign(data, customRef.getDate());
        }
        if (SuperPayPaymentRef) {
          data = Object.assign(data, SuperPayPaymentRef.getData());
        }
        if (LivenPaymentRef) {
          data = Object.assign(data, LivenPaymentRef.getData());
        }
        if (CashMachineRef) {
          data = Object.assign(data, CashMachineRef.getData());
        }
        const result = await PaymentMethodsService.updatePaymentMethods(this.info.selectedDevice.deviceUDID, data);
        if (result) {
          this.notyfy.success("Saved Successfully");
        } else {
          this.notyfy.error("Save Failed");
        }
      } catch (error) {
        this.notyfy.error("Save Failed");
      } finally {
        this.saving = false;
      }
    }
  }
});
